import { Pipe, PipeTransform } from '@angular/core';
import { toZonedTime } from 'date-fns-tz';
import { DANISH_TIMEZONE } from '../time.service';

@Pipe({
    name: 'danishTime',
    pure: true,
    standalone: true
})
export class DanishTimePipe implements PipeTransform {
    transform(date: Date): Date {
        return toZonedTime(date, DANISH_TIMEZONE);
    }
}
